// import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import React, {useContext, useState, useEffect } from 'react';

// components
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Preloader from "../components/Preloader";
import { Routes } from "../routes";


const PrivateRouteWithSidebar = ({ component: Component, ...rest }) =>{
  const { isAuthenticated } = useContext(AuthContext);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);
  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }
  return (
    <Route {...rest} render={(props) =>
      isAuthenticated ? (
        <>
          <Preloader show={loaded ? false : true} />
          <Sidebar />
          <main className="content">
            <Navbar />
            <Component {...props} />
            <Footer toggleSettings={toggleSettings} showSettings={showSettings} />
          </main>
        </>
      ) : (
        // <Redirect to="/pages/sign-in" />
        <Redirect to={Routes.Signin.path} />
      )
    }
    />
  );
}

export default PrivateRouteWithSidebar;
// export default PrivateRoute;